import React, { FC } from 'react';
import FontAwesomeIcon from '../../../../../ui/font-awesome-icon/font-awesome-icon';
import useIsMobile from '../../../../../hooks/use-is-mobile';
import CartItemPrice from '../cart-item-price/cart-item-price';
import CartItemTitle from '../cart-item-title/cart-item-title';
import './cart-item-header.scss';

type CartItemHeaderProps = {
    item: CartItem;
    itemIndex: number;
    onRemove: VoidFunction;
};

const CartItemHeader: FC<CartItemHeaderProps> = ({ item, itemIndex, onRemove }) => {
    const isMobile = useIsMobile(991);

    return (
        <div className='cart-item-header'>
            <CartItemTitle item={item.material} itemIndex={itemIndex} />

            {!isMobile && <CartItemPrice item={item} />}

            {isMobile && (
                <FontAwesomeIcon width={20} height={20} className='remove-icon' name='close' onClick={onRemove} />
            )}
        </div>
    );
};

export default CartItemHeader;
